/**
 * Native app lifecycle integration (#32 — IOS-3.6).
 *
 * On iOS, when the user backgrounds the app and returns, the access token may
 * have expired (15-min TTL). App.addListener('appStateChange') fires when the
 * app comes back to the foreground; we proactively refresh the token so the
 * next API call succeeds without a visible 401 flash.
 *
 * On web/PWA this is a no-op — the browser's Page Visibility API handles
 * background/foreground transitions natively and the apiFetch auto-refresh
 * on 401 is the fallback.
 */

import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'
import { tryRefresh } from '../lib/pfhApi'

let _registered = false

export function registerAppLifecycle(): void {
  if (!Capacitor.isNativePlatform() || _registered) return
  _registered = true

  void App.addListener('appStateChange', ({ isActive }) => {
    if (isActive) {
      // Proactively refresh on foreground; ignore failures (apiFetch retries on 401)
      void tryRefresh()
    }
  })
}
